import { render, staticRenderFns } from "./UnpublishedDialog.vue?vue&type=template&id=025fa8d0&scoped=true&"
import script from "./UnpublishedDialog.vue?vue&type=script&lang=js&"
export * from "./UnpublishedDialog.vue?vue&type=script&lang=js&"
import style0 from "./UnpublishedDialog.vue?vue&type=style&index=0&id=025fa8d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025fa8d0",
  null
  
)

export default component.exports